module.exports = __webpack_public_path__ + "static/img/bonus_2.c72008c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jzsg/bonus_2.png
// module id = iuW/
// module chunks = 0